import {Filesystem, Directory, Encoding} from '@capacitor/filesystem';
import {Capacitor} from "@capacitor/core";
import {MAX_RETRIES,INITIAL_DELAY,BACK_OFF_FACTOR} from "./constants";
import {Camera} from "@capacitor/camera";
import write_blob from "capacitor-blob-writer";


export const fileUtils = {

  fileReader: null,

  async handlePermissions() {
    // Check if on android or iOS app platform
    if (Capacitor.getPlatform() !== 'web') {

      // Check and request camera permissions.
      const cameraPermissionStatus = await Camera.checkPermissions();
      if (cameraPermissionStatus.camera === "granted" && cameraPermissionStatus.photos === "granted") {
      } else {
        const status = await Camera.requestPermissions({permissions: ['camera']});
      }

      // Send message to enable manually if it was denied and don't ask again
      const cameraPermission = await Camera.checkPermissions();
      if (cameraPermission.camera === "denied" && cameraPermission.photos === "denied") {
        alert('Dotag Camera and Media access permissions denied. Please add permissions manually or reinstall the app.');
        return false;
      } else {
        return true;
      }

    } else {
      // PC no cordova
    }
  },

  readFileUriCapacitor(url) {
    return Capacitor.convertFileSrc(url);
  },

  getStorageDirectory() {
    return this.getUri(Directory.Data, '');
  },

  getFilesDirectory() {
    return this.getUri(Directory.Data, 'files/');
  },

  getUri: async function (directory, path) {
    try {
      const {uri} = await Filesystem.getUri({path: path, directory: directory});
      //return Capacitor.convertFileSrc(uri);
      return uri;
    } catch (error) {
      console.error("Error getting URI:", error);
      return null;
    }
  },

  resizeBlob(blob, maxWidth, maxHeight) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(blob => {
          resolve({blob, width, height});
        }, 'image/jpeg');
      };
      img.onerror = function () {
        reject("Failed to load image");
      };
      img.src = URL.createObjectURL(blob);
    });
  },

  async readFileAsBase64(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return new Promise((resolve, reject) => {
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = error => reject(error);
    });
  },

  base64ToBlob(base64String, contentType) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], {type: contentType});
  },

  async saveBase64AsImage(fileName, base64String) {
    try {
      const savedFile = await Filesystem.writeFile({
        path: fileName,
        data: base64String,
        directory: Directory.Data,
        recursive: true
      });
      return savedFile.uri;
    } catch (error) {
      console.error('Error saving file:', error);
      throw error;
    }
  },

  async blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  },

  // BLOBS cant be saved by Capacitor natively
  // Depreciated by BlobWrite service by converting it before
  /*  async saveBlobAsFile(directory, fileName, DataBlob) {
      try {
        const base64Data = (await this.blobToBase64(DataBlob));
        const savedFile = await Filesystem.writeFile({
          path: fileName,
          data: base64Data,
          directory: directory,
          recursive: true
        });
        return savedFile.uri;
      } catch (error) {
        console.error('Error saving file:'+fileName, error);
        throw error;
      }
    },*/
  async saveBlobAsFile(directory, fileName, dataBlob) {
    try {
      await write_blob({
        path: fileName,
        directory: directory,
        blob: dataBlob,
        recursive: true,
        on_fallback(error) {
          console.error(error);
        }
      });
      return await this.getUri(directory, fileName);
    } catch (error) {
      console.error("Error saving blob as file:", error);
      return null;
    }
  },


  async deleteDirectory(directoryPath) {
    try {
      await Filesystem.rmdir({
        path: 'files/' + directoryPath,
        directory: Directory.Data,
        recursive: true
      });
      console.log('Directory deleted successfully');
    } catch (error) {
      console.log('Error deleting directory:', error);
    }
  },

  deleteFile: async function (filePath) {
    await Filesystem.deleteFile({
      path: filePath,
      directory: Directory.Data,
    });
  },

  createProjectFileDirectory: async function (folderName) {
    try {
      const directoryExists = await this.folderExists(folderName);
      if (!directoryExists) {
        await Filesystem.mkdir({
          path: 'files/' + folderName,
          directory: Directory.Data,
          recursive: false
        });
      }
    } catch (error) {
      console.log('Folder:' + folderName + '  Error:' + error);
    }
  },

  folderExists: async function (folderName) {
    try {
      const result = await Filesystem.stat({
        path: 'files/' + folderName,
        directory: Directory.Data
      });
      return result.type === 'directory';
    } catch (error) {
      return false;
    }
  },

  getBlobFromUrl: async function (url) {
    const initialDelay = INITIAL_DELAY ? INITIAL_DELAY : 500;
    const maxRetries = MAX_RETRIES ? MAX_RETRIES : 3;
    const backoffFactor = BACK_OFF_FACTOR ? BACK_OFF_FACTOR : 2;

    let attempt = 0;
    let currentDelay = initialDelay;

    while (attempt <= maxRetries) {
      try {
        const response = await fetch(url);

        if (!response.ok) {
          if ((response.status >= 500 || response.status === 429) && attempt < maxRetries) {
            throw new Error(`Retryable error: HTTP ${response.status}`);
          } else {
            throw new Error(`HTTP error: ${response.status}`);
          }
        }
        console.log('getBlobFromUrl: got response', response);
        return await response.blob();
      } catch (error) {
        console.log('error in getBlobFromUrl', error);
        if (attempt >= maxRetries) throw error;
        await new Promise(resolve => setTimeout(resolve, currentDelay));
        currentDelay *= backoffFactor;
        attempt++;
      }
    }
  },

  async getImageSizeByURL(imageURL) {
    return new Promise((resolve, reject) => {

      let img = new Image();

      img.onload = () => {
        resolve({
          width: img.width,
          height: img.height
        });
      };

      img.onerror = () => {
        reject();
      };

      img.src = imageURL;

    });
  },

  copyFileToFolder: async function (sourceImagePath, targetFolderPath, targetFileName, keepExistingFile) {
    return new Promise((resolve, reject) => {
      window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0, async fs => {
        window.resolveLocalFileSystemURL(sourceImagePath, function (fileEntry) {
            window.resolveLocalFileSystemURL(targetFolderPath, function (directoryEntry) {
              if (!keepExistingFile) {
                fileEntry.moveTo(directoryEntry, targetFileName, function () {
                  resolve();
                }, (err) => {
                  console.log('error in moveTo', err);
                  reject(err);
                });
              } else {
                fileEntry.copyTo(directoryEntry, targetFileName, function () {
                  resolve();
                }, (err) => {
                  console.log('error in copyTo', err);
                  reject(err);
                });
              }


            }, (err) => {
              console.log('error in resolveLocalFileSystemURL for targetFolderPath');
              reject(err);
            });
          }, (err) => {
            console.log('error in resolveLocalFileSystemURL for sourceImagePath');
            reject(err);
          }
        );
      });
    });
  },

  moveFolder: async function (sourceFolderPath, targetFolderPath, newFolderName, keepExistingFolder) {
    return new Promise((resolve, reject) => {
      window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0, async fs => {
        window.resolveLocalFileSystemURL(sourceFolderPath, function (sourceFolder) {
            window.resolveLocalFileSystemURL(targetFolderPath, function (targetFolder) {
              if (!keepExistingFolder) {
                sourceFolder.moveTo(targetFolder, newFolderName, function () {
                  resolve();
                }, (err) => {
                  console.log('error in moveTo', err);
                  reject(err);
                });
              } else {
                sourceFolder.copyTo(targetFolder, newFolderName, function () {
                  resolve();
                }, (err) => {
                  console.log('error in copyTo', err);
                  reject(err);
                });
              }


            }, (err) => {
              console.log('error in resolveLocalFileSystemURL for targetFolderPath');
              reject(err);
            });
          }, (err) => {
            console.log('error in resolveLocalFileSystemURL for sourceImagePath');
            reject(err);
          }
        );
      });
    });
  },


  blobToImgSrc: function (blob) {
    if (blob instanceof Blob) {
      return URL.createObjectURL(blob);
    }
    console.error('Invalid blob:', blob);
    return '';
  },

  getBlobFromLocalFile: async function (url, mimeType) {
    return new Promise((resolve, reject) => {
      if (Capacitor.getPlatform() !== 'web') {
        window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0, async fs => {
          window.resolveLocalFileSystemURL(url, function (fileEntry) {
            fileEntry.file(file => {
              fileUtils.fileReader = new FileReader();
              fileUtils.fileReader.onloadend = function (evt) {
                resolve(new Blob([evt.target.result], {type: mimeType}));
              };
              fileUtils.fileReader.onerror = (err) => {
                console.log('error reading file with readAsArrayBuffer', url);
                reject(err);
              };

              fileUtils.fileReader.readAsArrayBuffer(file);
            }, err => {
              console.log('error reading fileEntry', err);
              reject(err);
            });
          }, err => {
            console.log('error reading resolveLocalFileSystemURL', err, url);
            reject(err);
          });
        }, err => {
          console.log('error requestFileSystem', err);
          reject(err);
        });
      } else {

        this.getBlobFromUrl(url, mimeType).then(blob => {
          resolve(blob);
        }).catch(err => {
          console.log(err);
          reject(err);
        });
      }
    });
  },

  convertBase64ToBlob(base64Image) {
    // Split into two parts
    const parts = base64Image.split(';base64,');
    // Hold the content type
    const imageType = parts[0].split(':')[1];
    // Decode Base64 string
    const decodedData = window.atob(parts[1]);
    // Create UNIT8ARRAY of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);
    // Insert all character code into uInt8Array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // Return BLOB image after conversion
    return new Blob([uInt8Array], {type: imageType});
  },

  removeSpecialChars(str) {
    return str.replace(/(?!\w|\s)./g, '')
      .replace(/\s+/g, ' ')
      .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, '$2');
  },

  async getNativeURL(filePath) {
    return new Promise((resolve, reject) => {
      window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0, async fs => {
        resolveLocalFileSystemURL(filePath, function (entry) {
          resolve(entry.toURL());
        }, (err) => {
          console.log('error reading resolveLocalFileSystemURL', err, filePath);
          reject(err);
        });
      }, (err) => {
        console.log('error while running requestFileSystem', err, filePath);
        reject(err);
      });
    });
  }
};
